import initRecs, {
  getPlacementData,
  setHomePageContext,
  setBrandPageContext,
  setGenericPageContext,
  setErrorPageContext,
  loadScript as rrLoadScript,
  setCategoryPageContext,
} from '@rei/recommendations';

function sendAlgonomyMvtAnalytics(pageName) {
  if (!pageName) { return; }

  const mvts = window?.rr_mvtDetailed?.mvtDetailed
    ?.filter((mvt) => mvt.testName.includes(`|${pageName}|`))
    .map((mvt) => mvt.treatmentId)
    .join('_');

  if (mvts?.length) {
    window?.metrics?.link({ linkName: `Algonomy:${mvts}` });
  }
}

const getRecs = async (placements, context, canonicalName, pageName) => {
  const placementTypes = [];
  placements.forEach((element) => {
    placementTypes.push(element.placementType);
  });
  return rrLoadScript().then(() => {
    const pageContextCB = () => {
      if (context && context.toLowerCase() === 'home') {
        setHomePageContext();
      } else if (context && context.toLowerCase() === 'brand') {
        setBrandPageContext(canonicalName);
      } else if (context && context.toLowerCase() === 'category') {
        setCategoryPageContext(canonicalName);
      } else if (context && context.toLowerCase() === 'error') {
        setErrorPageContext();
      } else {
        setGenericPageContext();
      }
    };

    return new Promise((resolve, reject) => {
      const rrLoadFailed = setTimeout(() => {
        reject(new Error('rr timeout'));
      }, 5000);

      const rrCallback = () => {
        const recsModel = [];
        placements.forEach((element) => {
          const recsObj = {};
          const tiles = element.numRecommendations ? parseInt(element.numRecommendations, 10) : 6;
          const { message, items, strategy } = getPlacementData(element.placementType) || {};
          recsObj.recsMessage = message;
          recsObj.recsItems = items;
          recsObj.recsStrategy = strategy;
          recsObj.recsName = element.placementType;
          recsObj.recsTiles = tiles;
          recsModel.push(recsObj);
        });

        // We ensure that there are indeed recommendations to display on the page
        const hasRecs = recsModel.some((placement) => placement.recsItems?.length > 0);
        if (hasRecs) {
          sendAlgonomyMvtAnalytics(pageName);
        }

        clearTimeout(rrLoadFailed);
        resolve(recsModel);
      };

      initRecs({
        pageContextCB,
        rrCallback,
        placements: placementTypes,
      });
    });
  }).catch((err) => {
    // eslint-disable-next-line
    console.log('error', err);
    throw new Error();
  });
};

export { getRecs as default };
